


      var windowWidth = $(window).width();
        if(windowWidth <= 470 ){
        $('.has-sub-nav > a').click(function(e){
          e.preventDefault();
              $(this).parent().find('.nav__sub').slideToggle();  
        });
        }

        var windowWidth = $(window).width();
        if(windowWidth <= 470 ){
        $('.has-megamenu > a').click(function(e){
          e.preventDefault();
              $(this).parent().find('.nav__sub').slideToggle();  
        });
        }

        var windowWidth = $(window).width();
        if(windowWidth <= 470 ){
        $('.nav__item_mobile > a').click(function(e){
          e.preventDefault();
              $(this).parent().find('.nav__sub-item_mobile').slideToggle();  
        });
        }




$(document).on("click", ".quick-buy__dropdown-item-content h6", function () {
   
    var imgSrc = $(this).siblings("img").attr("src");
    $("body").addClass("popup-open");
    $(".popup__img img").attr("src", imgSrc);
    $(".popup").fadeIn();
});
  $(".popup__close , .overlay").on("click", function () {
        $(".popup").fadeOut();
        $("body").removeClass('popup-open');
    });


// collection start


function initCollectionTabs() {
    const tabButtons = document.querySelectorAll('.collection__tabs-btn');
    const collectionItems = document.querySelectorAll('.collection__items');

    // Function to switch tab
    function activateTab(type) {
        // Hide all items
        // collectionItems.forEach(item => {
        //     item.style.display = 'none';
        // });

        // Remove active class from all tabs
        tabButtons.forEach(btn => {
            btn.classList.remove('active');
        });

        // Show the matched item
        const targetItem = document.querySelector(`.collection__items[data-type="${type}"]`);
        if (targetItem) {
            targetItem.style.display = 'flex';
        }

        // Add active class to clicked tab
        const targetTab = document.querySelector(`.collection__tabs-btn[data-type="${type}"]`);
        if (targetTab) {
            targetTab.classList.add('active');
        }
    }

    // Set default visible tab (first one)
    const defaultType = tabButtons[0]?.getAttribute('data-type');
    if (defaultType) {
        activateTab(defaultType);
    }

    // Add event listeners to each tab button
    tabButtons.forEach(btn => {
        btn.addEventListener('click', function () {
            const type = this.getAttribute('data-type');
            activateTab(type);
        });
    });
}

// Run the function (you can call this manually too)
initCollectionTabs();




$(".collection__item-btn a").on('click', function () {
    $("body").addClass('quick-buy-popup-open');
})
$(".quick-buy__close , .overlay").on('click', function () {
    $("body").removeClass('quick-buy-popup-open');
})





// collection end



// quick-buy start




$(".quick-buy__dropdown-item").on('click', function () {
    const $this = $(this);

    if ($this.hasClass('active')) {
        // If already open, just close it
        $this.removeClass('active');
        $this.find('.quick-buy__dropdown-item-content').stop(true, true).slideUp(300);
    } else {
        // Close all others
        $('.quick-buy__dropdown-item').removeClass('active');
        $('.quick-buy__dropdown-item-content').stop(true, true).slideUp(300);

        // Open this one
        $this.addClass('active');
        $this.find('.quick-buy__dropdown-item-content').stop(true, true).slideDown(300);
    }
});




// quick-buy end





// hero marquee start


$(".marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

// hero marquee end



// best-seller start



$('.best-seller__tab-item').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.best-seller__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.best-seller__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




const tabButtons = document.querySelectorAll('.best-seller__tab-button');
const tabItems = document.querySelectorAll('.best-seller__tab-item');

tabButtons.forEach(button => {
    button.addEventListener('click', () => {
        const tabKey = button.getAttribute('data-tab');

        // Update button active state
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Update tab item active state
        tabItems.forEach(item => {
            if (item.getAttribute('data-tab') === tabKey) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    });
});

// Optional: Activate the first tab by default
if (tabButtons.length > 0) {
    tabButtons[0].classList.add('active');
    const defaultTab = tabButtons[0].getAttribute('data-tab');
    document.querySelector(`.best-seller__tab-item[data-tab="${defaultTab}"]`)?.classList.add('active');
}


// best-seller end



// text-marquee start


$(".text-marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

// text-marquee end



// benefits start


document.querySelectorAll('.benefits__item a').forEach(item => {
    item.addEventListener('click', function (e) {
        e.preventDefault();

        const type = this.closest('.benefits__item').getAttribute('data-type');

        // Hide all popups
        document.querySelectorAll('.benefits__popup').forEach(popup => {
            popup.classList.remove('popup-show');
        });

        // Show the matched popup
        const matchedPopup = document.querySelector(`.benefits__popup[data-type="${type}"]`);
        if (matchedPopup) {
            matchedPopup.classList.add('popup-show');
            document.body.classList.add('benefits__popup-show'); // ✅ Add class to body
        }
    });
});

// Close popup when clicking close icon
document.querySelectorAll('.benefits__popup .benefits__close, .overlay').forEach(btn => {
    btn.addEventListener('click', function () {
        // Remove 'popup-show' from all popups
        document.querySelectorAll('.benefits__popup').forEach(popup => {
            popup.classList.remove('popup-show');
        });

        // Remove class from body
        document.body.classList.remove('benefits__popup-show');
    });
});


//  $(".benefits__popup-content ul li a").on('click', function (e) {
//    e.stopPropagation(); 

// //     // Hide all popup sources
// //     $(".benefits__popup-source").removeClass('benefits__popup-source-show');

// //     // Show only the one inside this <li>
//    $(this).find(".benefits__popup-source").addClass('benefits__popup-source-show');
//  });

$(".benefits__popup-source-close").on('click', function (e) {
    e.stopPropagation();
    $(this).closest(".benefits__popup-source").removeClass('benefits__popup-source-show');
});










// benefits end




// reviews start



$('.reviews__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.reviews__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.reviews__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// reviews end




// gallery start



$('.gallery__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.gallery__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.gallery__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// gallery end



// vetted start



const vettedItemsContainer = document.querySelector('.vetted__items');
const vettedItems = document.querySelectorAll('.vetted__item');
const leftArrow = document.querySelector('.vetted__left-arrow');
const rightArrow = document.querySelector('.vetted__right-arrow');

// Rotate left
leftArrow.addEventListener('click', function () {
    rotateItems('left');
});

// Rotate right
rightArrow.addEventListener('click', function () {
    rotateItems('right');
});

// Handle rotation and reset flipped/active states
function rotateItems(direction) {
    vettedItemsContainer.classList.add(`moving-${direction}`);

    vettedItems.forEach(item => {
        const startPosition = parseInt(item.dataset.index);
        let endPosition = direction === 'right' ? startPosition + 1 : startPosition - 1;

        // Wrap around logic (assuming 3 items)
        if (endPosition > 3) endPosition = 1;
        if (endPosition < 1) endPosition = 3;

        item.dataset.index = endPosition;
        item.style.zIndex = endPosition.toString();

        // ✅ Reset flip and active on slide
        const imgBox = item.querySelector('.vetted__item-img');
        imgBox.classList.remove('flipped');
        item.classList.remove('active');
    });

    vettedItemsContainer.addEventListener('transitionend', function () {
        vettedItemsContainer.classList.remove(`moving-${direction}`);
    }, { once: true });
}

// Flip behavior when item is clicked
document.querySelectorAll('.vetted__item').forEach((item) => {
    item.addEventListener('click', function () {
        const imgBox = item.querySelector('.vetted__item-img');
        const isFlipped = imgBox.classList.toggle('flipped');

        // ✅ Sync .active class based on flipped state
        if (isFlipped) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
});




// vetted end




// carousel start



$('.carousel__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.carousel__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.carousel__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// carousel end





// faq-home start


$(".faq-home__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq-home__content").slideUp();
    } else {
        $(".faq-home__content").slideUp();
        $(".faq-home__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq-home__content").slideDown();
    }
})


// faq-home end






if ($(Window).width() < 768) {
    $(function () {
        const $dropdown = $(".best-seller__tab-dropdown");
        const $selected = $dropdown.find(".best-seller__tab-dropdown-selected");
        const $options = $dropdown.find(".best-seller__tab-button");

        // toggle dropdown
        $selected.on("click", function () {
            $dropdown.find(".best-seller__tab-buttons").toggle();
        });

        // option click
        $options.on("click", function () {
            let value = $(this).data("tab");
            let text = $(this).text();

            // update selected text
            $selected.text(text);

            // active state
            $options.removeClass("active");
            $(this).addClass("active");

            // close dropdown
            $dropdown.find(".best-seller__tab-buttons").hide();

            // এখানে চাইলে content filter show/hide ও add করা যাবে
            // $(".tab-content").hide().filter("[data-tab='" + value + "']").show();
        });

        // click outside close
        $(document).on("click", function (e) {
            if (!$(e.target).closest(".best-seller__tab-dropdown").length) {
                $dropdown.find(".best-seller__tab-buttons").hide();
            }
        });
    });
}
